import { render, staticRenderFns } from "./ViewMenu.vue?vue&type=template&id=696dbfeb&scoped=true&"
import script from "./ViewMenu.vue?vue&type=script&lang=js&"
export * from "./ViewMenu.vue?vue&type=script&lang=js&"
import style0 from "./ViewMenu.vue?vue&type=style&index=0&id=696dbfeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696dbfeb",
  null
  
)

export default component.exports